require("!!/Desenvolvimento/PMP/painel/node_modules/script-loader/addScript.js")(require("!!/Desenvolvimento/PMP/painel/node_modules/raw-loader/index.js!/Desenvolvimento/PMP/painel/node_modules/select2/dist/js/select2.full.js"))


//////////////////
// WEBPACK FOOTER
// /Desenvolvimento/PMP/painel/~/script-loader!/Desenvolvimento/PMP/painel/~/select2/dist/js/select2.full.js
// module id = ../../../../script-loader/index.js!../../../../select2/dist/js/select2.full.js
// module chunks = 36